<template>
    <div>
        <div class="chenggongye">
            <div class="fanhuilist" @click="xiangqingye"><i class="el-icon-arrow-left"></i>返回</div>
            <div style="text-align: center;margin-top: 88px;"><img src="./images/zuzhifucg.png" alt=""></div>
            <div style="text-align: center;margin-top: 20px;"><p class="goumaic">您的课程已购买成功</p></div>
            <div style="text-align: center;margin-top: 20px;"><p class="dingdan">订单号:{{dingdan}}</p></div>
            <div style="text-align: center;margin-top: 8px;"><p class="dingdan">您可点击返回，查看已购买课程开始学习上课</p></div>
            <div class="fanhui" @click="xiangqingye">返回</div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            dingdan: ''
        }
    },
    created() {
        this.dingdan = this.$route.params.setid
    },
    methods: {
        xiangqingye() {
            // 跳转课程详情
            this.$router.push({ path: `/yuekelist/${this.$route.params.shangpingid}/${this.$route.params.kechengid}` })
        }
    }
}
</script>
<style scoped>
p {
    margin:  0;
}
.fanhui {
    width: 98px;
    height: 32px;
    background: #ffffff;
    border: 1px solid #e7e7e7;
    border-radius: 4px;
    margin: 0 auto;
    font-size: 14px;
    font-family: PingFangSC-Regular;
    text-align: center;
    color: #999999;
    line-height: 32px;
    margin-top: 39px;
    }
.dingdan {
    font-size: 16px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    color: #999999;
    letter-spacing: 0.32px;
}
.goumaic {
    font-size: 24px;
    font-family: PingFang SC, PingFang SC-Semibold;
    font-weight: 600;
    color: #202020;
    letter-spacing: 0.48px;
}
.fanhuilist {
    font-size: 16px;
    font-family: PingFangSC-Regular;
    color: #4d4d4d;
    margin-top: 24px;
    margin-left: 40px;
 }
.chenggongye {
    width: 1260px;
    height: 676px;
    background: #ffffff;
    border-radius: 1px;
    margin: 0 auto;
    margin-top: 20px;
    overflow: hidden;
}
</style>